import api from './api';

export interface CostInfo {
  provider: string;
  model: string;
  cost_eur: number;
  input_tokens?: number;
  output_tokens?: number;
  cached_tokens?: number;
  duration_seconds?: number;
}

export interface TranscribeResult {
  transcript: string;
  cost: CostInfo;
}

export interface PtaAnalysisResult {
  general_info: string;
  section_6_1: string;
  section_6_2: string;
  section_6_3: string;
  cost: CostInfo;
}

export interface PtaCompactResult {
  section_6_1: string;
  section_6_2: string;
  section_6_3: string;
  cost: CostInfo;
}

export type PtaChapter = 'header' | 'ch2' | 'ch3' | 'ch4' | 'ch5';

export interface PtaChapterResult {
  chapter: PtaChapter;
  title: string;
  content: string;
  has_info: boolean;
  cost: CostInfo;
}

export const ptaService = {
  transcribe: async (
    file: File,
    language: string,
    onUploadProgress?: (percent: number) => void,
  ): Promise<TranscribeResult> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('language', language);

    const response = await api.post('/pta/transcribe', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 300_000,
      onUploadProgress: (e) => {
        if (onUploadProgress && e.total) {
          onUploadProgress(Math.round((e.loaded / e.total) * 100));
        }
      },
    });
    return response.data;
  },

  analyze: async (transcript: string, language: string): Promise<PtaAnalysisResult> => {
    const response = await api.post('/pta/analyze', { transcript, language }, {
      timeout: 300_000,
    });
    return response.data;
  },

  analyzeCompact: async (longText: string, language: string): Promise<PtaCompactResult> => {
    const response = await api.post('/pta/analyze-compact', { long_text: longText, language }, {
      timeout: 300_000,
    });
    return response.data;
  },

  analyzeChapter: async (
    transcript: string,
    language: string,
    chapter: PtaChapter,
  ): Promise<PtaChapterResult> => {
    const response = await api.post(
      '/pta/analyze-chapter',
      { transcript, language, chapter },
      { timeout: 300_000 },
    );
    return response.data;
  },
};
